import { React, useEffect, useState } from 'react'
//import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { Routes, Route, useNavigate } from 'react-router-dom'


//--- Estilos e íconos de Bootstrap ---//
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import './styles/styles.css'
//--- Estilos e íconos de Bootstrap ---//


//--- Página login ---//
//import { Login } from './components/Login/Login'
import { Login } from './components/Login/V2/Login'
//--- Página login ---//

//--- Página del registro del Ztudiante ---//
import { SignUp } from './components/SignUp/SignUp'
//--- Página del registro del Ztudiante ---//

//--- Páginas del Ztudiante ---//
//import { Dashboard } from './components/Dashboard/Student/Dashboard'
import { Dashboard } from './components/Dashboard/Student/V2/Dashboard'
import { Confirm } from './components/Confirm/Confirm'
//import { Course } from './components/Course/Course'
import { Course } from './components/Course/V2/Course'
//import { Viewer } from './components/Viewer/Viewer'
import { Viewer } from './components/Viewer/V2/Viewer'
//import { Results } from './components/Results/Results'
import { Results } from './components/Results/V2/Results'
//import { Items } from './components/Results/Items'
import { Items } from './components/Results/V2/Items'
// import { Result } from './components/Results/Result'
import { Download } from './components/Download/Download'
import { NotFound } from './components/Common/NotFound'
import { WebExam } from './components/Viewer/Exam/WebExam/WebExam'
import { Exam } from './components/Dashboard/Student/Sections/Exam/Exam'
import { Theorist } from './components/Dashboard/Student/Sections/Exam/Theorist'
//--- Páginas del Ztudiante ---//

//--- Páginas del Instructor ---//
import { Tables } from './components/Common/Tables'
//import { Ztudents } from './components/Dashboard/Instructor/Sections/Ztudents'
import { Ztudents } from './components/Dashboard/Instructor/Sections/V2/Ztudents'
//import { Groups } from './components/Dashboard/Instructor/Sections/Groups'
import { Groups } from './components/Dashboard/Instructor/Sections/V2/Groups'
//import { Group } from './components/Dashboard/Instructor/Sections/Group'
import { Group } from './components/Dashboard/Instructor/Sections/V2/Group'
import { InviteFromGroup } from './components/Dashboard/Instructor/Sections/V2/InviteFromGroup'
//import { Create } from './components/Dashboard/Instructor/Sections/Group/Create'
import { Create } from './components/Dashboard/Instructor/Sections/V2/Group/Create'
//import { Progress } from './components/Dashboard/Instructor/Sections/Progress'
import { Progress } from './components/Dashboard/Instructor/Sections/V2/Progress'
//import { Agenda } from './components/Dashboard/Instructor/Sections/Agenda'
import { Agenda } from './components/Dashboard/Instructor/Sections/V2/Agenda'
//import { Create as CreateAgenda } from './components/Dashboard/Instructor/Sections/Agenda/Create'
import { Create as CreateAgenda } from './components/Dashboard/Instructor/Sections/V2/Agenda/Create'
import { Live } from './components/Dashboard/Instructor/Sections/Live'
//import { Results as InstructorResults } from './components/Dashboard/Instructor/Sections/Results'
import { Results as InstructorResults } from './components/Dashboard/Instructor/Sections/V2/Results'
//import { Syllabus } from './components/Dashboard/Instructor/Sections/Syllabus'
import { Syllabus } from './components/Dashboard/Instructor/Sections/V2/Syllabus'
//import { Settings } from './components/Dashboard/Instructor/Sections/Settings'
import { Settings } from './components/Dashboard/Instructor/Sections/V2/Settings'
//import { ChangeGroup } from './components/Dashboard/Instructor/Sections/ChangeGroup'
import { ChangeGroup } from './components/Dashboard/Instructor/Sections/V2/ChangeGroup'
import { Licenses as InstructorLicenses } from './components/Dashboard/Instructor/Sections/V2/Licenses'
import { UsedLicenses as InstructorUsedLicenses } from './components/Dashboard/Instructor/Sections/V2/UsedLicenses'
import { Help as InstructorHelp } from './components/Dashboard/Instructor/Sections/V2/Help'
import { Support as InstructorSupport } from './components/Dashboard/Instructor/Sections/V2/Support'
//--- Páginas del Instructor ---//

//--- Páginas del Líder de proyecto ---//
import { Instructors as LeaderInstructors } from './components/Dashboard/Leader/Sections/Instructors'
import { Reports as LeaderReports } from './components/Dashboard/Leader/Sections/Reports'
import { Progress as LeaderProgress } from './components/Dashboard/Leader/Sections/Progress'
import { ChangeGroup as LeaderChangeGroup } from './components/Dashboard/Leader/Sections/ChangeGroup'
import { Licenses as LeaderLicenses } from './components/Dashboard/Leader/Sections/Licenses'
import { AssignLicenses as LeaderAssignLicenses } from './components/Dashboard/Leader/Sections/AssignLicenses'
import { UsedLicenses as LeaderUsedLicenses } from './components/Dashboard/Leader/Sections/UsedLicenses'
import { Help as LeaderHelp } from './components/Dashboard/Leader/Sections/Help'
import { Support as LeaderSupport } from './components/Dashboard/Leader/Sections/Support'
// import { ChangeGroups } from './components/Dashboard/Leader/Sections/ChangeGroups'
//--- Páginas del Líder de proyecto ---//

//--- Página de Ayuda (Ztudiante) ---//
import { Help } from './components/Help/V2/Help'
//--- Página de Ayuda (Ztudiante) ---//

//--- Páginas en general ---//
// import { Validate } from './components/Dashboard/Student/Sections/Validate/Validate'
import { Maintenance } from './components/Maintenance/Maintenance'
//import { ZtudentView } from './components/Dashboard/Instructor/Sections/ZtudentView'
import { ZtudentView } from './components/Dashboard/Instructor/Sections/V2/ZtudentView'
//--- Páginas en general ---//

//--- Páginas legales ---//
import { PrivacyNotice } from './components/Legals/PrivacyNotice'
//--- Páginas legales ---//

import { StudentSocketProvider } from './components/Providers/StudentSocketProvider'
import { Contact } from './components/Contact/Contact'
//import { TawkProvider, TawkManager } from './Support/Chat/Chat'


function App() {
  const navigate = useNavigate()

  //Propiedades:
  //activeElementClass = Establece los estilos que lleva el Tile al establecerlo como activo
  //isFavorite = Establece si el elemento debe mostrarse visualmente marcado como favorito

  //Educador
  // const tileEducatorElements = [
  //   { tileIconClass: 'bi bi-file-text', tileText: ' Agendar evaluación al grupo "Excel Academic 2 A"', activeElementClass: 'DegradedExcel' },
  //   { tileClassName: 'ms-3', tileIconClass: 'bi bi-graph-up-arrow', tileText: ' Ver resultados del grupo "Excel Academic 2 A"' },
  //   { tileClassName: 'ms-3', tileIconClass: 'bi bi-person-add', tileText: ' Agregar alumnos al grupo "Excel Academic 2 A"' }
  // ]

  // const tileEducatorElements1 = [
  //   { tileIconClass: 'bi bi-file-text', tileText: ' Agendar evaluación', isFavorite: true },
  //   { tileClassName: 'ms-3', tileIconClass: 'bi bi-graph-up-arrow', tileText: ' Informe en tiempo real', isFavorite: true },
  //   { tileClassName: 'ms-3', tileIconClass: 'bi bi-person-add', tileText: ' Importar alumnos', isFavorite: true }
  // ]

  // const tileEducatorSMElements = [
  //   { tileIconClass: 'bi bi-file-text', tileText: ' Administrar evaluaciones ' },
  //   { tileIconClass: 'bi bi-file-text', tileText: ' Administrar grupos' },
  //   { tileIconClass: 'bi bi-file-text', tileText: ' Administrar a mis alumnos' },
  //   { tileIconClass: 'bi bi-file-text', tileText: ' Progreso de mis alumnos' },
  //   { tileIconClass: 'bi bi-file-text', tileText: ' Ver resultados' },
  //   { tileIconClass: 'bi bi-file-text', tileText: ' Informe en tiempo real' },
  //   { tileIconClass: 'bi bi-file-text', tileText: ' Ver temarios' }
  // ]




  // Obtén los enlaces para un idioma específico, por ejemplo, "spa"
  //const infoCourse = Course.english

  // const changeLanguage = async (language = null, isLoginPage = false) => {
  //   try {
  //     const newSettings = await getSettings(language, isLoginPage) // Esperar a que getSettings termine
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  // /**
  //  * Función para obtener la configuración, una vez que termine de cargarse el componente
  //  */
  // useEffect(() => {
  //   // Cargar configuración al montar el componente (carga inicial)
  //   changeLanguage(null, true)
  // },[]) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar

  //const [activeComponent, setActiveComponent] = useState('Login') // Estado para controlar el componente activo
  const [current, setCurrent] = useState({})
  const [result, setResult] = useState({})
  const [showQuickAccess, SetShowQuickAccess] = useState({})
  //const [isFirstTimeToTakeExam, setIsFirstTimeToTakeExam] = useState(true)

  const [theme, setTheme] = useState('')
  const [fontSize, setFontSize] = useState('')

  //--- Funciones para mostrar u ocultar los componentes principales ---//
  // const ShowLoginView = () => {
  //   setActiveComponent('Login')
  // }

  // const ShowDashboardView = () => {
  //   setActiveComponent('Dashboard')
  // }

  // const ShowCourseView = () => {
  //   setActiveComponent('Course')
  // }

  // const ShowViewerView = () => {
  //   setActiveComponent('Viewer')
  // }

  // const ShowResultsView = () => {
  //   setActiveComponent('Results')
  // }
  //--- Funciones para mostrar u ocultar los componentes principales ---//

  const SetFontSizeToWeb = (fontSizeSelected) => {
    try {
      setFontSize(fontSizeSelected)

      document.getElementById('root').classList.remove('SmallFont', 'MediumFont', 'BigFont')
      document.getElementById('root').classList.add(fontSizeSelected)

      //Función para mandar a guardar el tamaño de fuente a la API
      //SaveWebFontSize(fontSizeSelected)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    document.getElementById('root').classList.add('BodyComplete')
  }, [])

  // Escucha el aviso de sesión expirada (disparado desde DoubleAttempt.js cuando el
  // backend confirma, tras un reintento, que el token ya no es válido) y redirige al
  // login mostrando el mismo aviso que ya existe ahí ("Tu sesión ha finalizado.
  // Ingresa nuevamente"), sin importar en qué página estuviera el usuario.
  useEffect(() => {
    const onSessionExpired = () => {
      navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
    }

    window.addEventListener('app:session-expired', onSessionExpired)
    return () => window.removeEventListener('app:session-expired', onSessionExpired)
  }, [navigate])


  try {
    return (
      <Routes>
        {/* Página login */}
        <Route
          path='/'
          element={
            //<Maintenance />
            <Login />
          }
        />

        {/* Páginas Ztudiante */}
        <Route
          path='/confirm'
          element={
            //<Maintenance />
            <Confirm />
          }
        />

        <Route
          path='/dashboard'
          element={
            //<Maintenance />
            <Dashboard />
          }
        />

        <Route
          path='/course'
          element={
            //<Maintenance />
            <Course />
          }
        />

        <Route
          path='/viewer'
          element={
            //<Maintenance />
            <Viewer />
          }
        />

        <Route
          path='/results'
          element={
            //<Maintenance />
            <Results />
          }
        />

        <Route
          path='/results/items'
          element={
            //<Maintenance />
            <Items />
          }
        />

        <Route
          path='/help'
          element={
            //<Maintenance />
            <Help />
          }
        />

        {/* <Route
              path='/exam'
              element={
                // //<Maintenance />
                // xam />
                <WebExam />
              }
            />

            <Route
              path='/exam/theorist'
              element={
                // //<Maintenance />
                <Thrist />
              }
            /> */}

        {/* <Route
              path='/results/items/result'
              element={<Result />}
            /> */}

        <Route
          path='/download'
          element={
            //<Maintenance />
            <Download />
          }
        />



        {/* Página para registro de nuevo Ztudiante - Desarrollo */}
        
        <Route
          path='/signup'
          element={
            //<Maintenance />
            <SignUp />
          }
        />



        {/* Página del Instructor - Desarrollo */}

        <Route
          path='/instructor/ztudents'
          element={
            //<Maintenance />
            <Ztudents />
          }
        />

        <Route
          path='/instructor/groups'
          element={
            //<Maintenance />
            <Groups />
          }
        />

        <Route
          path='/instructor/groups/group'
          element={
            //<Maintenance />
            <Group />
          }
        />

        <Route
          path='/instructor/groups/group/invite'
          element={
            //<Maintenance />
            <InviteFromGroup />
          }
        />

        <Route
          path='/instructor/groups/create'
          element={
            //<Maintenance />
            <Create />
          }
        />

        <Route
          path='/instructor/licenses'
          element={
            //<Maintenance />
            <InstructorLicenses />
          }
        />

        <Route
          path='/instructor/licenses/used'
          element={
            //<Maintenance />
            <InstructorUsedLicenses />
          }
        />

        <Route
          path='/instructor/progress'
          element={
            //<Maintenance />
            <Progress />
          }
        />

        <Route
          path='/instructor/agenda'
          element={
            //<Maintenance />
            <Agenda />
          }
        />

        <Route
          path='/instructor/agenda/create'
          element={
            //<Maintenance />
            <CreateAgenda />
          }
        />

        {/* <Route
              path='/instructor/live'
              element={<Live />}
            /> */}

        <Route
          path='/instructor/results'
          element={
            //<Maintenance />
            <InstructorResults />
          }
        />

        <Route
          path='/instructor/syllabus'
          element={
            //<Maintenance />
            <Syllabus />
          }
        />

        <Route
          path='/instructor/help'
          element={
            //<Maintenance />
            <InstructorHelp />
          }
        />

        <Route
          path='/instructor/support'
          element={
            //<Maintenance />
            <InstructorSupport />
          }
        />

        <Route
          path='/instructor/ztudentView'
          element={
            //<Maintenance />
            <ZtudentView />
          }
        />

        <Route
          path='/instructor/settings'
          element={
            //<Maintenance />
            <Settings />
          }
        />

        <Route
          path='/instructor/changeGroup'
          element={
            //<Maintenance />
            <ChangeGroup />
          }
        />



        {/* Página del Líder de proyecto - Desarrollo */}

        <Route
          path='/leader/instructors'
          element={
            //<Maintenance />
            <LeaderInstructors />
          }
        />

        <Route
          path='/leader/reports'
          element={
            //<Maintenance />
            <LeaderReports />
          }
        />

        <Route
          path='/leader/progress'
          element={
            //<Maintenance />
            <LeaderProgress />
          }
        />

        <Route
          path='/leader/groups'
          element={
            //<Maintenance />
            <LeaderChangeGroup />
          }
        />

        <Route
          path='/leader/licenses'
          element={
            //<Maintenance />
            <LeaderLicenses />
          }
        />

        <Route
          path='/leader/licenses/assign'
          element={
            //<Maintenance />
            <LeaderAssignLicenses />
          }
        />

        <Route
          path='/leader/licenses/used'
          element={
            //<Maintenance />
            <LeaderUsedLicenses />
          }
        />

        <Route
          path='/leader/help'
          element={
            //<Maintenance />
            <LeaderHelp />
          }
        />

        <Route
          path='/leader/support'
          element={
            //<Maintenance />
            <LeaderSupport />
          }
        />



        {/* <Route
              path='/table'
              element={<Tables tableConfig={tableConfig} />}
            /> */}

        {/* Página 404 */}
        <Route
          path='*'
          element={
            //<Maintenance />
            <NotFound />
          }
        />

        {/* Página Validate */}
        {/* <Route
              path='/validar'
              element={<Validate />}
            /> */}

        {/* Página de pruebas - Desarrollo */}
        {/* <Route
              path='/exam'
              element={<WebExam />}
            /> */}

        <Route
          path='/contact'
          element={
            //<Maintenance />
            <Contact />
          }
        />

        {/* LEGALES */}
        {/* Página Aviso de privacidad */}
        <Route
          path='/legals/privacy'
          element={
            //<Maintenance />
            <PrivacyNotice />
          }
        />
      </Routes>
    )
  } catch (error) {
    console.log(error)
  }
}

export default App;